module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-kalamba.202d5158.png";